import { AudioLines } from "lucide-react";

/* Temporary font-selection demo for The Rhythm Report — remove after Morgan picks. */

const OPTIONS = [
  {
    id: 1,
    name: "Wide & Light — your Bohren reference",
    note: "Thin, stretched, uppercase. Quiet luxury. The most 'upscale record store' of the four.",
    masthead: "rfd-wide",
    head: "rfd-wide",
    body: "rfd-arch",
  },
  {
    id: 2,
    name: "Fashion serif — Fraunces",
    note: "High-editorial magazine energy. Serif headlines, feels like a printed issue.",
    masthead: "rfd-fraunces",
    head: "rfd-fraunces",
    body: "rfd-arch",
  },
  {
    id: 3,
    name: "Poster condensed — Anton",
    note: "Loud, tall, tabloid-adjacent but cleaner. Big NME / poster energy.",
    masthead: "rfd-anton",
    head: "rfd-anton",
    body: "rfd-arch",
  },
  {
    id: 4,
    name: "Current — Archivo Black",
    note: "What's on the page now, for comparison.",
    masthead: "font-rhythm-display",
    head: "font-rhythm-display",
    body: "font-rhythm",
  },
];

function Sample({ opt }) {
  return (
    <section
      data-testid={`rhythm-font-option-${opt.id}`}
      className="border-b border-white/10 py-14"
    >
      <p className="font-rhythm-mono text-[11px] uppercase tracking-[0.22em] text-white/50">
        Option {opt.id} — {opt.name}
      </p>
      <p className="mt-1 font-rhythm-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
        {opt.note}
      </p>

      <p className={`mt-10 text-[11px] uppercase tracking-[0.5em] text-white/60 ${opt.body}`}>
        The
      </p>
      <h1 className={`${opt.masthead} mt-2 uppercase leading-[0.88] tracking-tight`}>
        <span className="block text-6xl text-[#F3F1ED] sm:text-7xl">Rhythm</span>
        <span className="block text-6xl text-white sm:text-7xl">Report</span>
      </h1>

      <div className="mt-9 flex items-center gap-4">
        <span className="h-[5px] w-14 bg-white" />
        <p className={`text-xs uppercase tracking-[0.3em] text-white/75 ${opt.body}`}>
          Music · Criticism · Discovery
        </p>
      </div>

      <div className="mt-10 grid gap-6 lg:grid-cols-2">
        <div className="rhythm-card rounded-2xl p-7">
          <p className={`text-xs uppercase tracking-[0.25em] text-white/60 ${opt.body}`}>
            Cover Story · Monday Unfiltered
          </p>
          <h2 className={`mt-3 text-3xl uppercase tracking-tight text-[#F3F1ED] ${opt.head}`}>
            Kendrick Lamar
          </h2>
          <p className="mt-2 font-garamond text-xl italic text-white/80">
            The victory lap that's secretly a mission statement.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-white/60">
            No rollout, no warning — just twelve songs that turned the year's loudest
            beef into a victory lap.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-white">
            <AudioLines className="h-4 w-4" /> 9.2 / 10
          </p>
        </div>
        <div className="rhythm-card rounded-2xl p-7">
          <p className={`text-xs uppercase tracking-[0.25em] text-white/60 ${opt.body}`}>
            Section header sample
          </p>
          <h2 className={`mt-3 text-3xl uppercase text-[#F3F1ED] ${opt.head}`}>
            New Music Friday
          </h2>
          <p className="mt-3 text-base leading-relaxed text-white/70">
            Body text sample — Archivo at rest. Reviews, picks and spotlights read in
            this voice; headlines and metadata carry the personality above.
          </p>
          <p className="mt-4 font-rhythm-mono text-[10px] uppercase tracking-[0.2em] text-white/45">
            Single · R&B · 2024 · New
          </p>
        </div>
      </div>
    </section>
  );
}

export default function RhythmFontsDemo() {
  return (
    <div className="min-h-screen bg-[#0B0A0F] font-rhythm text-[#F3F1ED]">
      <div className="mx-auto max-w-5xl px-5 py-14">
        <p className="font-rhythm-mono text-[11px] uppercase tracking-[0.22em] text-white/50">
          The Rhythm Report — font direction preview (temporary page)
        </p>
        <h1 className="mt-3 font-rhythm-mono text-lg uppercase tracking-[0.2em] text-white/80">
          Pick a voice for the masthead → tell Morgan's builder
        </h1>
        {OPTIONS.map((o) => (
          <Sample key={o.id} opt={o} />
        ))}
      </div>
    </div>
  );
}
